module.exports = __webpack_public_path__ + "img/mirror17.1bdc9663.jpg";